import { render } from "./TikTokStoryReview.vue?vue&type=template&id=01fd66d6&scoped=true"
import script from "./TikTokStoryReview.vue?vue&type=script&lang=js"
export * from "./TikTokStoryReview.vue?vue&type=script&lang=js"

import "./TikTokStoryReview.vue?vue&type=style&index=0&id=01fd66d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01fd66d6"]])

export default __exports__